module.exports = __webpack_public_path__ + "img/scene-public-charging.5c5be829.jpg";